import { Checkbox } from '@/components/ui/checkbox'
import type { MembershipLevel, MembershipLevelForm } from '@/pages/MembershipLevelsPage.types'

interface MembershipLevelChangeTargetsFieldProps {
  form: MembershipLevelForm
  level?: MembershipLevel
  levels: MembershipLevel[]
  onChange: (form: MembershipLevelForm) => void
}

export function MembershipLevelChangeTargetsField({
  form,
  level,
  levels,
  onChange,
}: MembershipLevelChangeTargetsFieldProps) {
  const targets = levels.filter((candidate) => candidate.id !== level?.id && !candidate.archived)

  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium">Members may switch to</legend>
      <p className="text-caption text-muted-foreground">
        Choose the other Membership Levels members may select. Leave empty to offer no self-service
        change.
      </p>
      {targets.map((target) => {
        const checked = form.levelChangeTargetIds.includes(target.id)
        return (
          <label key={target.id} className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={checked}
              onCheckedChange={(value) =>
                onChange({
                  ...form,
                  levelChangeTargetIds: value
                    ? [...form.levelChangeTargetIds, target.id]
                    : form.levelChangeTargetIds.filter((id) => id !== target.id),
                })
              }
            />
            {target.name}
          </label>
        )
      })}
    </fieldset>
  )
}
